<template>
  <b-row>
    <div class="col-md-12">
      <card class="stacked-form">
        <form v-on:submit.prevent="doSubmit">
          <b-row class="ml-0 mr-0 mb-5 mt-3" v-for="(line, index) in lines" v-bind:key="index">
            <b-col md="10 p-2">
              <h4><strong>List Item</strong></h4>
            </b-col>
            <b-col md="1 p-0 mt-3 text-center">
              <button type="button" @click="removeLine(index)" v-if="index >= 1" class="btn btn-danger"><i class="fa fa-times"></i></button>
            </b-col>
            <b-col md="1 p-0 mt-3 text-center">
              <b-button type="button" v-if="index + 1 === lines.length" @click="addLine" variant="primary" ><font-awesome-icon icon="plus"/></b-button>
            </b-col>
            <b-col md="12">
              <fg-input label="Product">
                <div class="form-group input-typeahead" v-bind:class="productError !== null ? 'has-error':''">
                  <typeahead ref="userProfileUuidTypeahead" customQueryParamName="name" :labelFields="['product_name']" placeholder="Cari Product" :urlSearch="apiUrl.productSearch" arr-response="data" :dataLineIndex="index" :model="line.product" :formType="'productSearch'" v-on:doCreateCutomer="getSize" />
                  <p v-if="productError !== null" class="error" v-html="productError"></p>
                </div>
              </fg-input>
            </b-col>
            <b-col mf="12" v-if="line.productSize.length !== 0">
              <table class="table table-bordered table-striped">
                <tr>
                  <th width="100">Varian</th>
                  <th width="150">Persedian</th>
                  <th width="250">Alasan</th>
                  <th width="250">Stok Saat Ini</th>
                  <th width="100"></th>
                </tr>
                <tr v-for="productSize in line.productSize" :key="productSize.id">
                  <td>{{productSize.size !== null ? productSize.size.name : '-'}}</td>
                  <td>{{productSize.stock}}</td>
                  <td>
                    <treeselect 
                      v-model="productSize.reason" 
                      class="mb-3" 
                      placeholder="Pilih kategori" 
                      :multiple="false"
                      :clear-on-select="true"
                      :options="reasonList" 
                      name="reason"
                      data-vv-as="reason" ></treeselect>
                    <small v-if="productSize.isError && productSize.reason === undefined" class="text-danger">Alasan tidak boleh kosong</small>
                  </td>
                  <td>
                    <b-form-input type="number" placeholder="Masukkan jumlah pengurangan" v-model="productSize.return"></b-form-input>
                  </td>
                  <td>
                    <template v-if="productSize.return">
                      <span :class="(productSize.return - productSize.stock) < 0? 'text-danger' : 'text-success'">{{(productSize.return - productSize.stock) < 0? '' : '+'}}{{productSize.return - productSize.stock}}</span>
                    </template>
                    <template v-else>0</template>
                  </td>
                </tr>
              </table>
            </b-col>
          </b-row>
          <cancel-button class="text-right"/>
          <div class="float-button-right">
            <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id === undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
          </div>
          
        </form>
      </card>
    </div>
  </b-row>
</template>
<script>
  import { DatePicker, Select, Option, Switch } from 'element-ui'
  import { Radio } from '@/components/index'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'
  import Typeahead from '@/components/Typeahead'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: {
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      [Option.name]: Option,
      [Select.name]: Select,
      [DatePicker.name]: DatePicker,
      LRadio: Radio,
      LSwitch: Switch,
      Typeahead,
      Treeselect
    },
    data () {
      return {
        downPaymentDisabled: true,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        apiUrl: {
          stockReturn: window.AppConfig.apiUrl + 'stock-return',
          // productSearch: window.AppConfig.apiUrl + 'product-search',
          productSize: window.AppConfig.apiUrl + 'product-size',
          productSearch: window.AppConfig.apiUrl + 'product-search-color'
        },
        productError: null,
        options: [
          { text: 'Male', value: '0' },
          { text: 'Famele', value: '1' }
        ],
        nameProduct: null,
        productionCost: 0,
        productList: [],
        lines: [],
        blockRemoval: true,
        ppn: 0,
        model: {
          name: null,
          productSize: null,
          stockIn: 0,
          reason: null,
          note: null
        },
        modelValidations: {
          name: {
            required: true
          },
          productSize: {
            required: true
          },
          stockIn: {
            required: true
          },
          reason: {
            required: true
          }
        },
        reasonList: [
          {
            id: 'Reject',
            label: 'Reject'
          },
          {
            id: 'Rusak',
            label: 'Rusaks'
          },
          {
            id: 'Salah Barang',
            label: 'Salah Barang'
          },
          {
            id: 'Miss Stock',
            label: 'Miss Stock'
          },
          {
            id: 'Giveaway',
            label: 'Giveaway'
          },
          {
            id: 'Adjutment',
            label: 'Adjutment'
          },
          {
            id: 'PLUS STOCK',
            label: 'PLUS STOCK'
          }
        ]
      }
    },
    watch: {
      'model.name': function (val) {
        if (val.length >= 3) {
          this.getProduct(val)
        }
      },
      lines () {
        this.blockRemoval = this.lines.length <= 1
      }
    },
    mounted () {
      this.initData()
      this.addLine()
    },
    methods: {
      getSize (value) {
        if (value.isRemove) {
          this.lines[value.dataLineIndex].productSize = []
        } else {
          this.$http.get(this.apiUrl.productSize + '/' + value.id).then(resp => {
            resp.data.forEach(data => {
              this.lines[value.dataLineIndex].productSize.push({
                id: data.id,
                product_color_id: value.id,
                size: data.size,
                stock: data.stock,
                ordered: 0,
                capital_price: data.capital_price
              })
            })
          })
        }
      },
      initData () {
        if (this.$route.params.id !== undefined) {
          this.getDetail()
        }
      },
      addLine () {
        // let checkEmptyLines = this.lines.filter(line => line.color === null)
        // if (checkEmptyLines.length >= 1 && this.lines.length > 0) return
        this.lines.push({
          product: {
            value: null,
            sellingPrice: 0,
            capitalPrice: 0
          },
          productSize: []
        })
      },
      removeLine (lineId) {
        if (!this.blockRemoval) this.lines.splice(lineId, 1)
      },
      getProduct (val) {
        this.$http.get(this.apiUrl.productSearch + '?name=' + val).then(resp => {
          this.productList = []
          resp.data.data.forEach(data => {
            this.productList.push({
              id: data.id,
              label: data.product_name
            })
          })
        })
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      },
      doSubmit () {
        this.saveButtonData.isLoading = true
        let products = []
        let isFalidReason = false
        this.lines.forEach((data, lineIndex) => {
          data.productSize.forEach((productSize, productSizeIndex) => {
            // if (productSize.return !== undefined && parseInt(productSize.return) !== 0) {
            //   if (productSize.reason !== undefined) {
            //     products.push({
            //       product_size_id: productSize.id,
            //       stock: productSize.return - productSize.stock,
            //       reason: productSize.reason,
            //       note: productSize.note
            //     })
            //   } else {
            //     data.productSize[productSizeIndex].isError = true
            //     isFalidReason = true
            //   }
            // }
            if (productSize.reason !== undefined) {
              products.push({
                product_size_id: productSize.id,
                stock: productSize.return - productSize.stock,
                reason: productSize.reason,
                note: productSize.note
              })
            }
          })
        })
        if (isFalidReason) {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/error', 'Kolom alasan masih ada yang kosong. Mohon periksa kembali.')
        } else if (products.length < 1) {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/error', 'List item tidak boleh kosong, minimal input harus 1 item.')
        } else {
          this.$http.post(this.apiUrl.stockReturn, {
            products: products
          }).then(response => {
            this.saveButtonData.isLoading = false
            this.$store.dispatch('notification/success', 'Stok berhasil di kembalikan.')
            this.lines = []
            this.$refs.userProfileUuidTypeahead[0].resetField()
            this.addLine()
          }).catch(error => {
            this.saveButtonData.isLoading = false
            this.$store.dispatch('notification/error', error)
          })
        }
      }
    }
  }
</script>

<style scooped>
  .fixed-top-selling {
    position: fixed;
    float: right !important;
    /* top: 0; */
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .fixed-top-downpayment {
    position: fixed;
    float: right !important;
    top: 48%;
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .float-button-right {
    position: fixed;
    right: 25px;
    bottom: 0;
  }
  .float-button-left {
    position: fixed;
    left: 0;
    bottom: 0;
  }
  .error .vue-treeselect__control {
    border: 1px solid red !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/StockIn/FormStockReturn.vue